export default __webpack_public_path__ + "static/media/latestNewsPreview.4894e9e7.png";